/* eslint-disable react/function-component-definition */

export default function isDarkModeSupportedPage(page: string) {
  return [
    "/",
    "/screener",
    "/financials",
    "/compare",
    "/coupons",
    "/issuers",
    "/discussions",
    "/fatos-relevantes",
    "/ranking",
    "/comments",
    "/feedback",
    "/blog",
  ].some((candidate) => {
    return candidate.length === 1 ? page === candidate : page.startsWith(candidate);
  });
}
